module.exports = __webpack_public_path__ + "static/logo@2x-e686088c12e6cc6e4e87c4302633cb62.png";